import { useCallback, useEffect, useState, type RefObject } from 'react'

/** Tela cheia de um elemento especifico (o palco, um tile, a sala inteira). */
export function useFullscreen(target: RefObject<HTMLElement | null>) {
    const [isFullscreen, setIsFullscreen] = useState(false)

    useEffect(() => {
        const sync = () => setIsFullscreen(document.fullscreenElement === target.current)
        document.addEventListener('fullscreenchange', sync)
        return () => document.removeEventListener('fullscreenchange', sync)
    }, [target])

    const toggle = useCallback(async () => {
        const element = target.current
        if (!element) return
        try {
            if (document.fullscreenElement) await document.exitFullscreen()
            else await element.requestFullscreen?.()
        } catch {
            // Navegador negou (gesto ausente, iframe sem allow): segue sem tela cheia.
        }
    }, [target])

    return { isFullscreen, toggle }
}
